import TextInputAuth from "components/TextInputAuth";
import React from "react";

type Person = {
  email: string;
  firstName: string;
  lastName: string;
};

type Props = {
  title: string;
  people: Person[];
  setPeople: (people: Person[]) => void;
  errors: any;
  checkEmail: (email: string, role: string) => void;
  rolePrefix: string;
  maxPeople?: number;
  isSecondDisabled?: boolean;
};

const PersonInput: React.FC<Props> = ({
  title,
  people,
  setPeople,
  errors,
  checkEmail,
  rolePrefix,
  maxPeople = 2,
  isSecondDisabled = false,
}): JSX.Element => {
  const handleChange = (index: number, field: keyof Person, value: string) => {
    const newPeople = [...people];
    newPeople[index] = { ...newPeople[index], [field]: value };
    setPeople(newPeople);
  };

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-col w-full">
        <div className="flex flex-row font-nunito font-normal text-xl text-black mb-1">
          {title}
        </div>
        {people.map((person, index) => {
          const isDisabled = index === 1 && isSecondDisabled;
          return (
            <div key={index} className="flex flex-row mb-4">
              <div className="flex flex-col w-1/3 mr-2">
                <TextInputAuth
                  placeholder={
                    rolePrefix === "child"
                      ? "optional"
                      : index === 0
                      ? "mandatory"
                      : "optional"
                  }
                  label="Email"
                  value={person.email}
                  onChange={(e: any) => {
                    handleChange(index, "email", e.target.value);
                  }}
                  onBlur={() =>
                    checkEmail(person.email, `${rolePrefix}[${index}]email`)
                  }
                  isHelp={errors?.[`${rolePrefix}[${index}]email`]}
                  helpText={errors?.[`${rolePrefix}[${index}]email`]}
                  disabled={isDisabled}
                />
              </div>
              <div className="flex flex-col w-1/3 mx-2">
                <TextInputAuth
                  placeholder="First Name"
                  label="First Name"
                  value={person.firstName}
                  onChange={(e: any) =>
                    handleChange(index, "firstName", e.target.value)
                  }
                  isHelp={errors?.[`${rolePrefix}[${index}]firstName`]}
                  helpText={errors?.[`${rolePrefix}[${index}]firstName`]}
                  disabled={isDisabled}
                />
              </div>
              <div className="flex flex-col w-1/3 ml-2">
                <TextInputAuth
                  placeholder="Last Name"
                  label="Last Name"
                  value={person.lastName}
                  onChange={(e: any) =>
                    handleChange(index, "lastName", e.target.value)
                  }
                  isHelp={errors?.[`${rolePrefix}[${index}]lastName`]}
                  helpText={errors?.[`${rolePrefix}[${index}]lastName`]}
                  disabled={isDisabled}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PersonInput;
